export default __webpack_public_path__ + "locales/si/UploadPanel.json?hash=9b082954cfa187d4b70d677d03de8a82";